import { TranslateService } from '@ngx-translate/core'

/** "1 day" or "2 days"; the catalogue has no plural forms of its own. */
export function formatDayCount(translateService: TranslateService, count: number): string {
  const key = Math.abs(count) === 1 ? 'MEETINGS.EXTEND_RETENTION.DAY' : 'MEETINGS.EXTEND_RETENTION.DAYS'
  return translateService.instant(key, { count })
}
